import { render } from "./NewsThumbsup.vue?vue&type=template&id=af8d40bc&scoped=true"
import script from "./NewsThumbsup.vue?vue&type=script&lang=js"
export * from "./NewsThumbsup.vue?vue&type=script&lang=js"

import "./NewsThumbsup.vue?vue&type=style&index=0&id=af8d40bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8d40bc"]])

export default __exports__